import { render, staticRenderFns } from "./ValidationRuleFormItem.vue?vue&type=template&id=13cc3077"
import script from "./ValidationRuleFormItem.vue?vue&type=script&lang=js"
export * from "./ValidationRuleFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports